//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
let d=[[[0,"CurrentStep",1,0],[0,"PlayModes",1,0],[0,"ScaleSpeed",1,0],[0,"ScaleStep",1,0],[0,"Speed",1,0]],[[[],"Stop",{},0,0],[[],"RewindToStart",{},0,0],[[],"StepBackward",{},0,0],[[],"PlayBackward",{},0,0],[[],"PlayForward",{},0,0],[[],"StepForward",{},0,0],[[],"ForwardToEnd",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.PlayButtonsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.PlayButtonsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.PlayButtonsBuilder.PlayModeValues = Object.freeze({
    "PlayOnce" : "PlayOnce", "LoopOver" : "LoopOver", "Retrace" : "Retrace"});

export default SPLM;